import {
  BasePageModel,
  basePageToLocal,
  DiffStates,
  KeyData,
  genKey,
  ProviderType,
  referenceNodeToLocal,
  referenceNodeToServer,
  KeyValuePair
} from '@interface/index';
import { ReferenceNode } from './parameter';

export const CONNECTION_TYPE = {
  SQL: 'mysql',
  GRAPHQL: 'graphql',
  WEBHOOK: 'webhook'
};

export function connectionTypeString(type: string) {
  switch (type) {
    case CONNECTION_TYPE.SQL:
      return 'SQL';
    case CONNECTION_TYPE.GRAPHQL:
      return 'GraphQL';
    case CONNECTION_TYPE.WEBHOOK:
      return 'WebHook';
    default:
      return '';
  }
}

export const DB_DIALECT_TYPE = {
  MYSQL: 'mysql',
  H2: 'h2',
  POSTGRES: 'postgres'
};

export enum CONNECTION_MODE {
  DEBUG = 'try_it_now',
  DEPLOY = 'deploy',
  MODULE_CONFIG = 'module_config',
  EXPORT = 'export',
  SYSTEM1 = 'system1',
  UNDEFINED = 'undefined',
  DEPLOY_PROVIDER = 'deploy_provider',
}

export interface Connection extends BasePageModel {
  mode: CONNECTION_MODE;
  agentId?: string;
  interfaceService: ReferenceNode; // deprecated
  services: ReferenceNode[];
  implementationService?: ReferenceNode;
  configuration: KeyValuePair[];
  configMeta?: string;
  masterSelf?: Connection;

  // knowledge
  knowledgeAgentId?: string;
}

export function connectionToLocal(data: any): Connection {

  const res = {
    ...basePageToLocal(data),
    agentId: data.agent_id,
    mode: data.mode,
    interfaceService: referenceNodeToLocal(data.interface_service) as ReferenceNode,
    services: (data.services || []).map(referenceNodeToLocal),
    implementationService: referenceNodeToLocal(data.implementation_service),
    configuration: data.configuration,
    configMeta: data.config_meta,
    masterSelf: data.master_self && connectionToLocal(data.master_self),
    knowledgeAgentId: data.knowledge_agent_id
  };

  return res;
}

export function connectionToServer(data: Connection) {

  return {
    id: data.id,
    name: data.name,
    mode: data.mode,
    interface_service: referenceNodeToServer(data.interfaceService),
    services: (data.services || []).map(referenceNodeToServer),
    implementation_service: referenceNodeToServer(data.implementationService),
    configuration: data.configuration,
    knowledge_agent_id: data.knowledgeAgentId
  };
}
